export const Trans_pt = {
    'projects': 'projetos',
    'users': 'usuários',
    'tools': 'Ferramentas',
    'there are no options to list': 'Não há opções para listar',
    'select Option': 'Selecione a opção',
    'insert number': 'inserir número',
    'insert text': 'Insira o texto',
    'all Rights Reserved': 'todos os direitos reservados',
    'create project': 'criar projeto',
    'project title': 'título do projeto',
    'project status': 'status do projeto',
    'project type': 'Tipo de projeto',
    'episodes': 'episódios',
    'episode': 'episódio',
    'duration': 'duração',
    'genre': 'gênero',
    'production base country': 'país base de produção',
    'production point person': 'pessoa de contato da produção',
    'develop point person': 'pessoa de contato do desenvolvimento',
    'short synopsis': 'sinopse curta',
    'add more information': 'Adicione mais informações',
    'create': 'criar',
    'cancel': 'cancelar',
    'projects pipeline': 'Pipeline de projetos',
    'share': 'compartilhar',
    'filter': 'filtro',
    'export': 'exportar',
    'search': 'procurar',
    'title': 'título',
    'status': 'status',
    'type': 'tipo',
    'existing material': 'material existente',
    'pre production start': 'início pré produção',
    'pre-production start': 'Início da pré-produção',
    'production end': 'final de produção',
    'episode 1': 'Episódio 1',
    '50% completed': '50% concluídos',
    'budget': 'orçamento',
    'budgets': 'orçamentos',
    'file': 'Arquivo',
    'chapter': 'capítulo',
    'potencial clients': 'clientes potenciais',
    'writer(s)': 'escritor(es)',
    'director(s)': 'diretor(es)',
    'writers': 'escritores',
    'directors': 'diretores',
    'writer': 'escritor',
    'director': 'diretor',
    'client': 'cliente',
    'tentative cast': 'elenco provisório',
    'talent': 'talento',
    'login': 'início de sessão',
    'continue': 'Prosseguir',
    'your user is not created on Production logik, please contact': 'Seu usuário não foi criado no Logik de produção, entre em contato',
    'search project': 'pesquisar projeto',
    'go back': 'voltar',
    'view': 'visualizar',
    'parameters': 'parâmetros',
    'production plan': 'Plano de produção',
    'chapters': 'capítulos',
    'scenes': 'cenas',
    'characters': 'personagens',
    'locations': 'locações',
    'elements': 'elementos',
    'shooting schedule': 'planos diários',
    'calendar': 'calendário',
    'minutes': 'minutos',
    'receive': 'receber',
    'search chapters': 'pesquisar capítulos',
    'view scenes': 'Ver cenas',
    'deliver chapter': 'entregar capítulos',
    'deliver': 'entregar',
    'add scene': 'adicione cena',
    'hide totals': 'ocultar totais',
    'on location': 'na localização',
    'on set': 'em set',
    'loc int day': 'loc int dia',
    'loc int night': 'loc int noite',
    'loc ext day': 'loc ext dia',
    'loc ext night': 'loc ext noite',
    'protections': 'proteções',
    'prod scenes': 'cenas prod',
    'shooting date': 'data da gravação',
    'location': 'locação',
    'unit': 'unidade',
    'vehicles': 'veículos',
    'other elements': 'Outros elementos',
    'events': 'eventos',
    'description': 'Descrição',
    'comments': 'comentários',
    'receive date': 'Data de Recebimento',
    'drag and drop here or click to browse a file': 'Arraste ou clique aqui para adicionar um arquivo',
    'comment': 'comentário',
    'receive chapter': 'receber capítulo',
    'scene type': 'Tipo de cena',
    'chapter from': 'capítulo de',
    'chapter to': 'capítulos até',
    'units': 'unidades',
    'date from': 'data de',
    'date to': 'data até',
    'location / studio': 'locação / estúdio',
    'day / night': 'dia / noite',
    'filter scenes': 'filtrar cenas',
    'only selected characters': 'Apenas caracteres selecionados',
    'at least one selected character': 'pelo menos um personagem selecionado',
    'element categories': 'categorias de elementos',
    'protection types': 'Tipos de proteção',
    'only added scenes': 'apenas cenas adicionadas',
    'only establishing shoot': 'apenas planos de estabelecimento',
    'only flashback': 'Apenas flashback',
    'only manually produced': 'apenas produzido manualmente',
    'scene number': 'Número da cena',
    'day history': 'história do dia',
    'year': 'ano',
    'page': 'página',
    'pages': 'Páginas',
    'establishing shoot': 'foto de localização',
    'produced': 'produzido',
    'click to add new character': 'Clique para adicionar novo personagem',
    'click to add new element': 'Clique para adicionar novo elemento',
    'click to add new event': 'Clique para adicionar novo evento',
    'click to add new comment': 'Clique para adicionar novo comentário',
    'character role': 'papel do personagem',
    'character': 'personagem',
    'category': 'categoria',
    'element': 'elemento',
    'event type': 'tipo de evento',
    'quantity': 'quantidade',
    'view scene detail': 'Ver detalhes da cena',
    'assign scene': 'atribuir cena',
    'edit scene': 'Editar cena',
    'duplicate scene': 'cena duplicada',
    'cancel scene': 'Cancelar cena',
    'delete scene': 'excluir cena',
    'this shooting schedule status is': 'esse plano de filmagem está em qual estado',
    'call': 'chamada',
    'shoot': 'gravação',
    'lunch': 'almoço',
    'day': 'dia',
    'shooting schedules': 'planos diários',
    'advance call': 'Chamada antecipada',
    'physical locations': 'Locais físicos',
    'nearest hospital': 'Hospital mais próximo',
    'monday': 'Segunda-feira',
    'tuesday': 'terça-feira',
    'wednesday': 'quarta-feira',
    'thursday': 'quinta-feira',
    'friday': 'Sexta-feira',
    'saturday': 'sábado',
    'sunday': 'Domingo',
    'requirements': 'requisitos',
    'log': 'registro',
    'rehearsal start': 'início de ensaio',
    'rehearsal end': 'final de ensaio',
    'shooting start': 'início da gravação',
    'shooting end': 'fim da gravação',
    'character / talent': 'personagem / talento',
    'make up': 'Maquiagem',
    'wardrobe': 'vestuário',
    'arrive': 'chegada',
    'notes': 'notas',
    'talent call': 'chamada de talento',
    'no talent assigned': 'nenhum talento designado',
    'add': 'adicionar',
    'save': 'Salve',
    'time': 'hora',
    'add advance call': 'Adicione a chamada antecipada',
    'add new location': 'Adicione nova locação',
    'add basecamp': 'Adicione Base',
    'physical location': 'locação física',
    'add physical location': 'Adicione a locação física',
    'physical location percent': 'Porcentagem de locação física',
    'studio percent': 'porcentagem de estúdio',
    'weeks on location': 'semanas em locação',
    'weeks on studio': 'Semanas no estúdio',
    'location days': 'dias de locação',
    'average location days': 'média de dias em locação',
    'studio days': 'Dias de estúdio',
    'average studio days': 'média de dias em estúdio',
    'maximum minutes to produce location': 'máximo de minutos para produzir em locação',
    'maximum minutes to produce studio': 'máximo de minutos para produzir em estúdio ',
    'reference minutes to produce daily location': 'Minutos de referência para produzir locação diária',
    'reference minutes to produce daily studio': 'Minixos de referência para produzir estúdio diário',
    'average minutes to produce daily location': 'Minutos médios para produzir localização diária',
    'average minutes to produce daily studio': 'Minutos médios para produzir estúdio diário',
    'scenes breakdown': 'cenas discriminadas',
    'maximum scenes location': 'máxima de cenas em locação',
    'maximum scenes studio': 'máxima de cenas em estúdio',
    'hospital name': 'Nome do hospital',
    'address': 'Endereço',
    'city': 'cidade',
    'country': 'país',
    'state': 'Estado',
    'add talent call': 'Adicione a chamada de talento',
    'there are no extras assigned to this shooting schedule': 'não há extras atribuídos a este plano diário',
    'extras type': 'tipo de figuração',
    'add extras call': 'adicionar chamada figuração',
    'extras call': 'chamada figuração',
    'unit cost': 'custo unitário',
    'total cost': 'custo total',
    'services': 'Serviços',
    'description / vendor': 'Descrição / fornecedor',
    'observations': 'Observações',
    'vendor': 'fornecedor',
    'contact person': 'pessoa de contato',
    'contact phone': 'telefone de contato',
    'add service': 'Adicionar serviço',
    'no services created for this category': 'Nenhum serviço criado para esta categoria',
    'shooting logs': 'bitacora de gravação',
    'scene': 'cena',
    'shooting times': 'horas de gravação',
    'add log': 'adicionar bitacora',
    'no crew added for this deparment': 'Nenhuma tripulação adicionada para este departamento',
    'add crew call': 'Adicionar chamada de tripulação',
    'edit crew call': 'Editar chamada de tripulação',
    'job': 'cargo',
    'department': 'departamento',
    'user': 'usuário',
    'add new user': 'adicionar novo usuário',
    'given name': 'nome',
    'surename': 'Surename',
    'add radio': 'Adicionar rádio',
    'frecuency': 'frequência',
    'close': 'fechar',
    'publish': 'publicar',
    'release': 'liberar',
    'release scene': 'cena de liberação',
    'confirm': 'confirmar',
    'unrelease': 'reatribuir',
    'unproduce': 'desproduzir',
    'unrelease scene': 'reatribuir cena',
    'unproduce scene': 'desproduzir cena',
    'add image': 'adicionar imagem',
    'link to scene': 'link para a cena',
    'shooting time': 'tempo de gravação',
    'days': 'dias',
    'crew call on set': 'Chamada de equipe no set',
    'ready to shoot': 'pronto para gravar',
    'unit name': 'Nome da unidade',
    'shootings': 'planos',
    'weekly shooting reports': 'relatório semanal de gravação',
    'view report': 'Ver relatório',
    'continuity': 'continuidade',
    'set continuity': 'continuidade da set',
    'view all': 'ver tudo',
    'delete image': 'excluir imagem',
    'add continuity': 'Adicione a continuidade',
    'upload a maximum of': 'Carregar no máximo',
    'images at a time': 'imagens no tempo',
    'choose files or drag them here': 'Escolha arquivos ou arraste -os aqui',
    'observation': 'observação',
    'insert': 'inserir',
    'there are no continuity images created': 'Não há imagens de continuidade criadas',
    'order table': 'Tabela de pedidos',
    'modification': 'modificação',
    'there are no shooting schedule created': 'Não há cronograma de filmagem criado',
    'main cast': 'elenco principal',
    'daily cast': 'elenco diário/apoio',
    'date': 'data',
    'filter shooting schedule': 'filtrar planos',
    'add unit': 'Adicionar unidade',
    'start date': 'data de início',
    'end date': 'data final',
    'view shooting schedule': 'ver plano de filmagem',
    'no events added to this scene': 'Nenhum evento adicionado a esta cena',
    'no crew added for this department': 'Nenhuma equipe adicionada para este departamento',
    'in case of emergency contact': 'Em caso de contato de emergência',
    'general call': 'chamada geral',
    'next shooting': 'próxima chamada',
    'merge': 'unificar',
    'merge set': 'unificar sets',
    'location from': 'locação de',
    'location to': 'locação para',
    'set from': 'set de',
    'set to': 'set para',
    'all scenes assigned to': 'Todas as cenas atribuídas a',
    'will be moved to': 'será movido para',
    'onces you reassign them, this cannot be roolback': 'uma vez reatribuído não pode ser revertido',
    'chapters reports': 'Relatórios de capítulos',
    'report': 'relatório',
    'color box': 'caixa de Cores',
    'copy data from scene': 'Copiar dados da cena',
    'system will copy characters and elements from scene selected': 'sistema copiará caracteres e elementos das cenas selecionadas',
    'edit': 'editar',
    'delete': 'excluir',
    'scene status': 'status da cena',
    'proj minutes': 'minutos proy',
    'prod minutes': 'minutos prod',
    'non eff minutes': 'minutos não efetivados',
    'secondary cast': 'elenco secundário',
    'scene detail': 'detalhe da cena',
    'copy': 'copiar',
    'pre production weeks': 'semanas de pré -produção',
    'production weeks': 'semanas de produção',
    'post production weeks': 'Semanas de pós produção',
    'wrap weeks': 'semanas de desprodução',
    'work days per week': 'Dias de trabalho por semana',
    'emitions per week': 'Emissões por semana',
    'air weeks': 'semanas no ar',
    'number units': 'número de unidades',
    'with two cameras': 'com duas câmeras',
    'weeks and days': 'semanas e dias',
    'unit weeks': 'semanas unitárias',
    'calendar weeks': 'semanas de calendário',
    'days/units': 'dias/unidades',
    'calendar days': 'dias do calendário',
    'real production days': 'dias reais de produção',
    'unit days': 'dias unitários',
    'countries': 'países',
    'production countries': 'países de produção',
    'international trips': 'viagens internacionais',
    'number of cities': 'número de cidades',
    'national trips': 'viagens nacionais',
    'round trip': 'ida e volta',
    'non work days': 'dias sem trabalho',
    'opening and promotions (EPK)': 'abertura e promos (EPK)',
    'international displacements': 'Transferência internacional',
    'national displacements': 'transferência nacional',
    'holidays': 'feriados',
    'free saturdays': 'Sábados livres',
    'planning meetings': 'reuniões de planos',
    'name city': 'Nome da cidade',
    'days to reduce': 'dias para reduzir',
    'percent': 'por cento',
    'minutes per chapter': 'minutos por capítulo',
    'margin': 'margem',
    'material per chapter': 'Material por capítulo',
    'maximum minutes to produce': 'Máximo de minutos para produzir',
    'reference minutes to produce daily': 'minutos de referência para produzir diariamente',
    'reference scenes to produce daily on location': 'cenas de referência para produzir diariamente em locação',
    'reference scenes to produce daily studio': 'Cenas de referência para produzir diariamente em estúdio',
    'average minutes to produce daily': 'Minutos médios para produzir diariamente',
    'average': 'média',
    'average scenes to produce daily location': 'cenas médias para produzir diariamente em locação',
    'average scenes to produce daily studio': 'cenas médias para produzir diariamente em estúdio',
    'maximum scenes': 'máximo de cenas',
    'scenes to reduce in chapter': 'cenas a serem reduzidas por capítulo',
    'maximum scenes to produce': 'cenas máximas para produzir',
    'reference scenes to produce daily': 'cenas de referência para produzir diariamente',
    'opening and promotions (epk)': 'abertura e promoções (EPK)',
    'average scenes to produce daily': 'cenas médias para produzir diariamente',
    'minimum per chapter': 'Mínimo por capítulo',
    'shooting schedule scenes': 'cenas previstas para filmagem',
    'shooting schedule scenes on location': 'cenas previstas para filmagem em locação',
    'shooting schedule scenes on studio': 'cenas previstas para filmagem em estúdio',
    'lead actors participation': 'participação do elenco principal',
    'lead actor daily participation': 'Participação diária de elenco principal',
    'lead actor daily scenes': 'cenas diárias de elenco',
    'lead actor daily scenes location': 'cenas diárias do elenco principal em locação',
    'lead actor daily scenes studio': 'Dias de trabalho de elenco protagonista',
    'lead actor non work days': 'Dias de trabalho de ator líder',
    'maximum scenes on location with lead actor': 'Máximo de cenas com elenco protagonista em locação',
    'maximum scenes on studio with lead actor': 'Máximo de cenas com elenco protagonista em estúdio',
    'maximum scenes with lead actor': 'Máximo de cenas com elenco protagonista',
    'maximum scenes in chapters with lead actor': 'Máximo de cenas por episódio com elenco protagonista',
    'maximum participation lead actor': 'máximo de participação de elenco protagonista',
    'calendar days lead actor': 'dia de calendário de elenco protagonista',
    'other actors': 'outros atores',
    'supporting actors (atl)': 'atores de apoio (ATL)',
    'guest stars': 'estrelas convidadas',
    'day players': 'extras',
    'extra large': 'extra grande',
    'large': 'ampla',
    'medium': 'médio',
    'small': 'pequena',
    'in serie': 'na Série',
    'per chapter': 'por capítulo',
    'budget locations': 'Orçamento de locações',
    'average new locations': 'média de novas locações',
    'maximum written locations': 'máximo de locações escritas',
    'difference written vs budget': 'Diferença escrita vs orçamento',
    'locations with lead': 'locações com protagonista',
    'rate exchange': 'taxa de câmbio',
    'working unit days': 'Dias da unidade de trabalho',
    'non working unit days': 'Dias de não unidade de trabalho',
    'real working unit days': 'Dias reais de trabalho',
    'ref minutes daily': 'ref minutos por dia',
    'avg minutes daily': 'media minutos por dia',
    'ref scenes daily': 'ref cenas diárias',
    'real scenes daily': 'real cenas diárias',
    'previous shooting': 'planos anteriores',
    'todays shooting': 'os planos de hoje',
    'actual scenes': 'cenas reais',
    'actual minutes': 'minutos reais',
    'proj scn': 'cen proj',
    'diff': 'dif',
    'post non used minutes': 'minutos não usados em pós',
    'real difference minutes': 'diferença real minutos',
    'daily avergae': 'média diária',
    'difference': 'diferença',
    'new average': 'nova média',
    'extra days': 'dias extras',
    'one or more scenes belong to an recording shooting schedule': 'Uma ou mais cenas pertencem a um cronograma de gravação',
    'there is a shooting schedule already closed for the date and unit selected': 'Já existe um cronograma de filmagem fechado para a data e a unidade selecionada',
    'this scene number already exist on this chapter': 'Este número de cena já existe neste capítulo',
    'this scenes has been assigned to a shooting schedule, an cannot be deleted': 'esta cena foi atribuída a um plano diário e não pode ser eliminada',
    'character roles': 'papéis de personagem',
    'filter characters': 'filtro personagem',
    'edit character': 'editar personagem',
    'change talent': 'mudar talento',
    'remove talent': 'Remova o talento',
    'artistic name': 'nome artístico',
    'download report': 'baixar relatório',
    'edit location': 'Editar localização',
    '1st chap': '1iro cap',
    '%scn.': '%cen.',
    'scn.': 'cen.',
    'c scn.': 'C cen.',
    'edit set': 'editar set',
    'delete set': 'excluir set',
    'category element': 'categoria do elemento',
    '1st chap.': '1 cap.',
    'shooting schedule reports': 'relatório do plano diário',
    'call sheet': 'chamada diária',
    'scn prod': 'Cen Prod',
    'written scenes': 'cenas escritas',
    'maximum written scenes': 'Cenas máximas escritas',
    'night exterior scenes': 'Cenas externas noturnas',
    'calculated': 'calculado',
    'maximum written': 'máximo escrito',
    'differnece written vs budget': 'diferença escrita versus orçamentada',
    'scenes per chapter': 'cenas por capítulo',
    'days per episode': 'dias por episódio',
    'breakdown': 'discriminar',
    'actual difference': 'diferença real',
    'projection': 'projeção',
    'projected difference': 'diferença projetada',
    'scn': 'Cen',
    'ch': 'cap',
    'ch scn': 'cen cap',
    'ch min': 'min cap',
    'totals': 'totais',
    'daily average': 'média diária',
    'extra shootings': 'chamadas adicionais',
    'january': 'janeiro',
    'february': 'fevereiro',
    'march': 'março',
    'april': 'abril',
    'may': 'maio',
    'june': 'Junho',
    'july': 'Julho',
    'augost': 'Agosto',
    'september': 'setembro',
    'october': 'Outubro',
    'november': 'novembro',
    'december': 'dezembro',
    'create holliday': 'criar um feriado',
    'character not available': 'personagem não disponível',
    'location not available': 'Locação não disponível',
    'add unit event': 'adicionar evento na unidade',
    'available': 'disponível',
    'not available': 'não disponível',
    'remove unit': 'Remover a unidade',
    'select option': 'Selecione a opção',
    'set available': 'set disponível',
    'remove holliday': 'Remova feriado',
    'received_abb': 'rec',
    'cancel_abb': 'can',
    'difference_abb': 'diff',
    'cummulative_difference_abb': 'dif acum',
    'assigned_abb': 'plano',
    'budget_abb': 'pres',
    'retakes_abb': 'Rep',
    'non_effective_abb': 'não efe',
    'effective_abb': 'efe',
    'budget_chapters_abb': 'Bud chp',
    'budget_scenes_abb': 'cen pres',
    'budget_minutes_abb': 'min pres',
    'effective_difference_abb': 'dif efe',
    'set shooting as private': 'definir plano como privado',
    'set shooting as tentative': 'definir como tentativa de plano',
    'all produced scenes will become unproduce': 'Todas as cenas produzidas se tornarão sem produção',
    'cum_projected_abb': 'Proj',
    'cum_received_abb': 'rec',
    'cum_difference_abb': 'diff',
    'cum_chapters_projected_abb': 'Acu cap proj',
    'cum_chapters_received_abb': 'Acu cap rec',
    'cum_chapters_difference_abb': 'Acu cap dif',
    'week': 'semana',
    'weekly chapyters': 'Capítulos semanais',
    'cumm chapters': 'capítulos acumulados',
    'weekly scenes': 'cenas semanais',
    'cummulative scenes': 'Cenas acumuladas',
    'cummulative chapters': 'capítulos acumulados',
    'weekly minutes': 'minutos semanais',
    'cummulative minutes': 'Minutos acumulados',
    'proj ch': 'cap proj',
    'rec ch': 'cap rec',
    'ch diff': 'dif cap',
    'prod scn': 'cen prod',
    'can scn': 'cen can',
    'rep scn': 'cen rep',
    'scn diff': 'cen dif',
    'eff scn diff': 'dif cen film',
    'can min': 'min can',
    'min diff': 'dif min',
    'eff min dif': 'dif efe min',
    'is not available on this date': 'não está disponível nesta data',
    'for this unit on this date': 'Para esta unidade nesta data',
    'sets reports': 'relatórios de set',
    'sets report': 'Relatório de set',
    'set in chapters': 'sets em capítulos',
    'elements reports': 'Relatórios de elementos',
    'elements report': 'Relatório de elementos',
    'element in chapters': 'elemento nos capítulos',
    'chapters parameters': 'Parâmetros dos capítulos',
    'chapter parameters': 'Parâmetros do capítulo',
    'characters detail': 'Detalhe de personagens',
    'locations detail': 'Detalhe de locações',
    'events detail': 'Detalhe de eventos',
    'characters parameters': 'Parâmetros de personagens',
    'locations parameters': 'Parâmetros de locações',
    'events parameters': 'Parâmetros de eventos',
    'sets': 'sets',
    'per ch': 'por cap',
    'avg': 'med',
    'pages per chapter': 'Páginas por capítulo',
    'written scenes per chapter': 'cenas escritas por capítulo',
    'breakdown scenes per chapter': 'cenas discriminadas por capítulo',
    'breakdown scenes and protections per chapter': 'cenas e proteções discriminadas por capítulo',
    'pages difference': 'diferença de páginas',
    'written scenes difference': 'Diferença de cenas escritas',
    'breakdown scenes difference': 'diferença de cenas discriminadas',
    'content parameters': 'Parâmetros de conteúdo',
    'written minutes difference': 'diferença de minutos escritos',
    'written minutes': 'Minutos escritos',
    'manually produced': 'produzido manualmente',
    'manually produced minutes': 'Minutos produzidos manualmente',
    'minutes to produce': 'minutos para produzir',
    'minutes to produce difference': 'diferença de minutos para produzir',
    'manually produced scenes': 'cenas produzidas manualmente',
    'scenes to produce': 'cenas para produzir',
    'scenes parameters': 'Parâmetros de cenas',
    'scenes day': 'cenas dia',
    'scenes night': 'cenas noite',
    'scenes interior': 'cenas interior',
    'scenes exterior': 'cenas exterior',
    'scenes interior day': 'cenas dia interior',
    'scenes exterior day': 'cenas dia exterior',
    'scenes interior night': 'cenas noite interior',
    'scenes exterior night': 'cenas noite exterior',
    'cast parameters': 'parâmetros de elenco',
    'lead and supporting cast playing': 'participação de personagens principais e de apoio',
    'new characters lead and supporting cast': 'novos personagens principais e de apoio',
    'lead and supporting cast difference': 'diferencia entre caracteres principais e secundários',
    'guest stars playing': 'participação de atores convidados',
    'new guest stars': 'Novas estrelas convidadas',
    'guest star difference': 'diferença de estrela convidada',
    'day players playing': 'participação de elenco de apoio',
    'new day players': 'novo elenco de apoio',
    'day players difference': 'diferença elenco de apoio',
    'extras playing': 'participação figuração',
    'new extras': 'nova figuração',
    'extras difference': 'diferença figuração',
    'stunts playing': 'participação dublês',
    'new stunts': 'novos dublês',
    'stunts difference': 'diferença dublês',
    'characters with out role': 'Personagens sem papel',
    'production parameteres': 'parâmetros de produção',
    'new locations': 'novas locações',
    'playing locations': 'participação de locações',
    'aircrafts': 'aeronaves',
    'songs': 'músicas',
    'new locations difference': 'diferença novas locações',
    'small events': 'eventos pequenos',
    'medium events': 'eventos médios',
    'large events': 'grandes eventos',
    'extra large events': 'eventos extras grandes',
    'song': 'música',
    'filter elements': 'filtro elementos',
    'categories': 'categorias',
    'there are no results to show': 'Não há resultados para mostrar',
    'elements in chapters': 'elementos em capítulos',
    'songs in chapters': 'músicas em capítulos',
    'songs reports': 'Relatórios de músicas',
    'edit song': 'editar música',
    'songs report': 'Relatório de músicas',
    'in development': 'Em desenvolvimento',
    'set as new': 'definido como novo',
    'set in development': 'definido no desenvolvimento',
    'set finished / bougth': 'definido acabado / comprado',
    'interfaces in chapters': 'interfaces em capítulos',
    'interfaces reports': 'Relatórios de interfaces',
    'interfaces report': 'Relatório de interfaces',
    'edit interface': 'Editar interface',
    'event types': 'Tipos de eventos',
    'production parameters': 'Parâmetros de produção',
    'weekly sumary': 'resumo semanal',
    'asg scn': 'cen atr',
    'asg min': 'min atr',
    'weeks': 'semanas',
    'participation': 'participação',
    'eff scn': 'cen efe',
    'view totals': 'Ver totais',
    'day.': 'dia.',
    'event': 'evento',
    'edit event': 'editar evento',
    'delete event': 'excluir evento',
    'add event': 'adicionar Evento',
    'scenes_assigned_abb': 'cen atr',
    'scenes_produced_abb': 'cen prod',
    'produced_minutes_abb': 'cen min',
    'daily_produced_scenes_average_abb': 'cen p dia',
    'edit unit': 'editar unidade',
    'delete unit': 'Excluir unidade',
    'number': 'número',
    'name': 'nome',
    'story country': 'país da história',
    'production country': 'país de produção',
    'synopsis': 'sinopse',
    'pitched to': 'apresentado para',
    'next steps / deadline': 'Próximos passos',
    'tentative dates': 'datas provisórias',
    'edit project,': 'editar projeto',
    'delete project': 'excluir projeto',
    'budget episode': 'orçamento do episódio',
    'scenes per day': 'cenas por dia',
    '100% completed': '100% concluído',
    'next steps': 'próximos passos',
    'holliday': 'feriado',
    'weekly chapters': 'Capítulos semanais',
    'projected chapters': 'Capítulos projetados',
    'projected scenes': 'cenas projetadas',
    'projected minutes': 'minutos projetados',
    'view chapter': 'Ver capítulo',
    'days to comment': 'dias para comentar',
    'version': 'versão',
    'complete': 'completo',
    '"brand"': '"marca"',
    '"brands"': '"Marcas"',
    'there are no images to show': 'Não há imagens para mostrar',
    'there are no cash advances created': 'não há adiantamentos em dinheiro criados',
    'add images': 'Adicionar imagens',
    'edit brand': 'editar marca',
    'previous': 'anterior',
    'next': 'próximo',
    'uploaded': 'carregado',
    'new scene': 'nova cena',
    'characters reports': 'Relatórios de personagens',
    'characters report': 'Relatório de personagens',
    'characters in chapters': 'Personagens nos capítulos',
    'generating': 'gerando',
    'uploading': 'carregando',
    'locations reports': 'relatórios de locações',
    'locations report': 'relatário de locação',
    'locations in chapters': 'locações por capítulo',
    'finance': 'finança',
    'add nearest hospital': 'Adicionar hospital mais próximo',
    'produced minutes': 'minutos produzidos',
    'start shooting': 'início da gravação',
    'end shooting': 'fim da gravação',
    'script report': 'relatório de roteiro',
    'link scenes': 'cenas vinculadas',
    'linked scenes': 'cenas vinculadas',
    'shoot description': 'descrição de gravação',
    'director notes': 'Notas do diretor',
    'selected': 'selecionado',
    'no brands added to this scene': 'Nenhuma marca adicionada a esta cena',
    'there are no characters created': 'Não há personagens criados',
    'script report template': 'modelo de relatório de roteiro',
    'talent call template': 'Modelo de chamada de talento',
    'crew call template': 'Modelo de chamada da equipe',
    'upload template': 'carregar modelo',
    'upload': 'carregar',
    'there was an error with the following scenes': 'Houve um erro nas seguintes cenas',
    'there was an error with the following clips': 'Houve um erro com os seguintes clipes',
    'move': 'mover',
    'publish shooting': 'publicar plano diário',
    'close shooting': 'fechar plano diário',
    're open shooting': 'reabrir o plano diário',
    'move shooting schedule': 'mover o plano diário',
    'cancel shooting schedule': 'Cancelar o plano diário',
    'weekly shootings report': 'Relatório semanal de planos diários',
    'general parameters': 'Parâmetros gerais',
    'continuity characters': 'caracteres de continuidade',
    'continuity character': 'caractere de continuidade',
    'continuity days': 'dias de continuidade',
    'continuity sets': 'sets de continuidade',
    'continuity day': 'Dia da continuidade',
    'all images': 'todas as imagens',
    'all images sets': 'todas imagens de set',
    'all images characters': 'todas imagens de personagens',
    'there are no results': 'Não há resultados',
    'not started': 'não foi iniciado',
    'closed': 'Fechado',
    'open': 'Aberto',
    'number of characters': 'número de personagens',
    'there are no elements created': 'Não há elementos criados',
    'delete brand': 'excluir marca',
    'post production': 'pós-produção',
    'add brand': 'Adicionar marca',
    'prod center': 'centro prod',
    'pre prod start': 'início pre prod',
    'prod start': 'início prod',
    'prod end': 'fim prod',
    'post start': 'início pós',
    'post end': 'fim pós',
    'add crew': 'adicionar equipe',
    'edit crew': 'editar equipe',
    'there is no crew created': 'não há equipe criada',
    'activate': 'ativar',
    'deactivate': 'desativar',
    'delete crew': 'excluir equipe',
    'logout': 'sair da sessão',
    'change image': 'mudar imagem',
    'upload project image': 'Carregue a imagem do projeto',
    'potential clients': 'potenciais clientes',
    'client feedback': 'feedback cliente',
    'completed': 'concluído',
    'create scene': 'criar cena',
    'copy from scene': 'cópia da cena',
    'real working unit days loc': 'dias reais de unidade de trabalho em locação',
    'real working unit days std': 'dias reais de unidade de trabalho em estúdio',
    'filter locations': 'filtro locações',
    'filter sets': 'filtro sets',
    'add catering': 'adicionar catering',
    'name - job': 'nome - cargo',
    'general producer': 'Produtor Geral',
    'summary report': 'Relatório de resumo',
    'daily scenes detail report': 'Relatório de detalhe de cenas diárias',
    'user type': 'tipo de usuário',
    'uncancel': 'restaurar',
    'productions': 'produções',
    'un cancel shooting schedule': 'restaurar plano diário',
    'uncancel shooting schedule': 'restaurar plano diário',
    'delete shooting schedule': 'excluir plano de gravação',
    'continuity set': 'continuidade set',
    'written scenes on location': 'cenas escritas em locação',
    'written scenes on studio': 'cenas escritas em estúdio',
    'written scenes on location difference': 'diferença cenas escritas em locação',
    'written scenes on studio difference': 'diferença cenas escritas em estúdio',
    'first call': 'primeira chamada',
    'calls': 'chamadas',
    'there are no logs created on this shooting schedule': 'Não há registros criados neste plano diário',
    'production start': 'início de produção',
    'upload character image': 'Carregue a imagem do personagem',
    'none': 'Nenhum',
    'events reports': 'Relatório de eventos',
    'events report': 'Relatórios de eventos',
    'edit continuity image': 'Editar imagem de continuidade',
    'phone': 'telefone',
    'production coordinator': 'coordenador de produção',
    'line producer': 'line producer',
    'production office': 'Escritório de Produção',
    'photographer': 'fotografia',
    'production manager': 'Diretor de produção',
    'publish tentative': 'publicar tentativa',
    'as tentative': 'como tentativa',
    'tentative name': 'nome tentativa',
    'unassign scene': 'cancelar a atribuição de cena',
    'tentative': 'tentativa',
    'tentatives': 'tentativas',
    'published shootings': 'planos publicados',
    'tentative lunch': 'tentativa almoço',
    'requirments calls': 'chamadas de requisitos',
    'crew call': 'Chamada da equipe',
    'on loc': 'em loc',
    'set as tentative': 'passar a tentativa',
    'pre-breakdown': 'pré-desdobramento',
    'private': 'privado',
    'not assigned': 'não atribuído',
    'assigned': 'atribuído',
    'produced assigned': 'produzido atribuído',
    'repetition': 'repetição',
    'not assigned protection': 'Proteção não atribuída',
    'assigned protection': 'proteção atribuída',
    'produced protection': 'Proteção produzida',
    'sides report': 'Relatório de lados',
    'filter budget': 'filtro orçamento',
    'amount': 'quantia',
    'delete budget': 'Excluir orçamento',
    'account codes': 'códigos de conta',
    'description english': 'Descrição Inglês',
    'description spanish': 'Descrição Espanhol',
    'code': 'código',
    'childs': 'filhos',
    'edit account code': 'Editar código da conta',
    'add account code': 'Adicionar código da conta',
    'parent': 'pai',
    'account code': 'Código de conta',
    'add child': 'Adicionar criança',
    'project': 'projeto',
    'currency': 'moeda',
    'wbs name': 'Nome da wbs',
    'phase': 'fase',
    'edit wbs': 'Editar WB',
    'wbs type': 'Tipo de wbs',
    'create budget': 'criar orçamento',
    'import budget': 'importar orçamento',
    'account': 'conta',
    'pre production': 'pré-produção',
    'production': 'Produção',
    'surname': 'sobrenome',
    'new user': 'novo usuário',
    'insert email': 'Insira o email',
    'given names': 'nome',
    'edit user': 'Editar usuário',
    'delete user': 'deletar usuário',
    'new budget': 'Novo orçamento',
    'commited': 'comprometido',
    'actuals': 'reais',
    'expend': 'gastar',
    'avl': 'disp',
    'bud': 'orç',
    'cash advance detail': 'Detalhes de adiantamento em dinheiro',
    'add invoice': 'Adicione a fatura',
    'base cost': 'custo base',
    'taxes': 'impostos',
    'concept,': 'conceito',
    'requested by': 'solicitado por',
    'value': 'valor',
    'approval': 'aprovação',
    'there are no previous requests': 'Não há solicitações anteriores',
    'invoices': 'faturas',
    'invoice': 'fatura',
    'cash advance': 'adiantamento em dinheiro',
    'submit': 'enviar',
    'to legalize': 'para legalizar',
    'approvals': 'aprovações',
    'review': 'revisão',
    'on review': 'em revisão',
    'view detail': 'ver detalhes',
    'request': 'solicitar',
    'cash advance request': 'solicitação de adiantamento em dinheiro',
    'open request': 'solicitação aberta',
    'there are no invoices created': 'Não há faturas criadas',
    'previous request': 'solicitação anterior',
    'requested': 'Requeridos',
    'approve': 'aprovar',
    'reject': 'rejeitar',
    'filter cash advances': 'filtrar adiantamentos em dinheiro',
    'departments': 'departamentos',
    'vendors': 'fornecedores',
    'edit request': 'Solicitação de edição',
    'edit invoice': 'Editar Fatura',
    'invoice number': 'Número da fatura',
    'vendor type': 'Tipo de fornecedor',
    'vendor name': 'nome do vendedor',
    'vendor document': 'Documento do fornecedor',
    'vendor document or number': 'Documento ou número do fornecedor',
    'vendor number': 'número de fornecedor',
    'vendor code': 'Código do vendedor',
    're open': 'reabrir',
    'retentions': 'retenções',
    'vendor detail': 'Detalhes do fornecedor',
    'vendor documents': 'Documentos do fornecedor',
    'document': 'documento',
    'production center': 'centro de produção',
    'cost': 'custo',
    'retention tax': 'Nombre de Trabajo / Servicio',
    'center': 'descrição de trabajo / servicio',
    'drag and drop here or click to browse files': 'Tipo de Contrato',
    'last call': 'Tipo de Pago',
    'scenes participation': 'participação em cena',
    'history days': 'Costo STM',
    'prod chapters': 'Arquivos',
    'closed days': 'agregar contrato',
    'scene header': 'Contrato',
    'location or set': 'Localização ou set',
    'chapter #': 'Declaração Costo por',
    'contract #': 'Sem feno Comentarios',
    'job / service name': 'Trabalho / Nome do serviço',
    'job / service description': 'Trabalho / Descrição do serviço',
    'type of contract': 'Cenas um produtor dirio en locação',
    'payment type': 'Cenas um produtor dihario en estúdio',
    'sign date': 'Minutos A Producir Diarios en locação',
    'cost stm': 'Minutos um produtor diroios en estúdio',
    'files': 'arquivos',
    'add contract': 'adicionar contrato',
    'contract': 'contrato',
    'contracts': 'contratos',
    'cost per statement': 'custo por declaração',
    'there are no comments': 'Não há comentários',
    'contract number': 'número do contrato',
    'no files added': 'nenhum arquivo adicionado',
    'scenes to produce daily on location': 'cenas para produzir diariamente em locação',
    'scenes to produce daily on studio': 'cenas para produzir diariamente no estúdio',
    'minutes to produce daily on location': 'minutos para produzir diariamente em locação',
    'minutes to produce daily on studio': 'minutos para produzir diariamente no estúdio',
    'minutes daily loc': 'min loc diários',
    'minutes daily std': 'min estd diários',
    'scenes daily loc': 'cen loc diários',
    'scenes daily std': 'cen estd diários',
    'chap': 'cap',
    'others': 'outros',
    'original design': 'design original',
    'there was an error duplicating this project': 'Houve um erro duplicando este projeto',
    'ubication': 'Localização',
    'there are no brands created': 'Não há marcas criadas',
    'brands report': 'Relatório de marcas',
    'brands in chapters': 'Marcas nos capítulos',
    'duplicating project': 'Projeto de duplicação',
    'duplicated project': 'projeto duplicado',
    'duplicate project': 'projeto duplicado',
    'periphery': 'periferia',
    'filter services': 'filtro serviços',
    'add purchase order': 'Adicione o pedido de compra',
    'service': 'serviço',
    'add files': 'adicionar arquivos',
    'delete service': 'Excluir serviço',
    'delete file': 'Excluir arquivo',
    'take': 'tomada',
    'plane': 'plano',
    'shot': 'gravação',
    'camera': 'Câmera',
    'clip note': 'Nota de clipe',
    'director note': 'Nota do diretor',
    'ingested': 'ingerido',
    'not found': 'não encontrado',
    'services template': 'Modelo de Serviços',
    'mark as pending': 'marcar como pendente',
    'mark as new': 'marcar como novo',
    'mark on process': 'marcar em processo',
    'on process': 'em processo',
    'edit purchase order': 'Editar pedido de compra',
    'purchase order': 'Ordem de Compra',
    'edit catering': 'Editar catering',
    'delete catering call': 'eliminar chamada catering',
    'monthly service': 'serviço mensal',
    'monthly': 'por mês',
    'include monthly services': 'Inclua serviços mensais',
    'left over': 'sobrou',
    'chapters color box': 'Capítulos Caixa de cores',
    'edited': 'editado',
    'brands usage': 'uso de marcas',
    'brands per chapter': 'Marcas por capítulo',
    'add role': 'Adicione papel',
    'add type': 'Adicionar tipo',
    'new clips': 'Novos clipes',
    'ingested clips': 'Clipes ingeridos',
    'synced clips': 'clipes sincronizados',
    'not found clips': 'clipes não encontrados',
    'camera position': 'posição de câmera',
    'weekly days': 'dias semanais',
    'approved': 'aprovado',
    'submitted': 'submetido',
    'legalize': 'legalizar',
    'legalized': 'legalizado',
    'partial legalized': 'parcialmente legalizado',
    'rejected': 'rejeitado',
    'banking expenses': 'despesas bancárias',
    'create cash advance for a vendor': 'criar adiantamento em dinheiro para um fornecedor',
    'support file': 'arquivo de suporte',
    'support files': 'arquivos de suporte',
    'download document guide': 'baixar guia de documentos',
    'max chapters': 'máx capítulos',
    'there is no shooting schedule on date selected': 'Não há cronograma de filmagem na data selecionada',
    'submitted by': 'enviado por',
    'are you sure you want to submit': 'tem certeza que deseja enviar',
    '$submit': 'enviar',
    'services on this daily plan are not submitted': 'Os serviços neste plano diário não foram enviados',
    'caterings on this daily plan are not submitted': 'Caterings neste plano diário não foram enviados',
    'beneficiary': 'beneficiário',
    'delete invoice': 'Excluir fatura',
    'delete cash advance': 'Excluir adiantamento em dinheiro',
    'submit cash advance': 'Enviar adiantamento em dinheiro',
    'invoices summary': 'Resumo das faturas',
    'invoices detail': 'Faturas detalhadas',
    'update vendors': 'Atualizar fornecedores',
    'deposit': 'depósito',
    'new invoice': 'Nova fatura',
    'paid value': 'valor pago',
    'base value': 'valor base',
    'total value invoice': 'valor total da fatura',
    'approve all': 'aprovar tudo',
    'date new': 'nova data',
    'date submitted': 'Data Enviada',
    'date approved': 'data aprovada',
    'date review': 'Revisão da data',
    'date legalized': 'data legalizada',
    'date rejected': 'data rejeitada',
    'reject cash advance': 'rejeitar adiantamento em dinheiro',
    'there are no cash advances to show': 'Não há adiantamentos em dinheiro para mostrar',
    'reports': 'relatórios',
    'download': 'baixar',
    'requested date from': 'data solicitada de',
    'requested date to': 'data solicitada para',
    'approved date from': 'Data aprovada de',
    'approved date to': 'data aprovada para',
    'rejected date from': 'data rejeitada de',
    'rejected date to': 'data rejeitada para',
    'legalized date from': 'data legalizada de',
    'legalized date to': 'data legalizada para',
    'without': 'sem',
    'with': 'com',
    'chapters list': 'Lista de capítulos',
    'scenes list': 'Lista de cenas',
    'protections list': 'Lista de proteções',
    'date created': 'Data Criada',
    'date updated': 'data atualizada',
    'all rights reserved': 'todos os direitos reservados',
    'add comment': 'adicionar comentário',
    'insert date': 'Inserir data',
    'to': 'para',
    'of': 'do',
    'add physical locations': 'adicionar locações físicas',
    'view script': 'Ver script',
    'add clip': 'Adicionar clipe',
    'edit clip': 'Editar clipe',
    'selected clip': 'clipe selecionado',
    'edit service': 'Serviço de edição',
    'edit call': 'editar chamada',
    'edit comment': 'Editar comentário',
    'delete call': 'excluir chamada',
    'delete radio': 'Excluir rádio',
    'delete comment': 'Excluir  comentário',
    'delete clip': 'Excluir clipe',
    'create holiday': 'Criar feriado',
    'production roles': 'funções de produção',
    'general roles': 'papéis gerais',
    'add user': 'adicionar usuário',
    'project user type': 'Tipo de usuário do projeto',
    'name english': 'Nome em inglês',
    'name spanish': 'Nome em espanhol',
    'edit role': 'função de edição',
    'edit type': 'Editar tipo',
    'delete account code': 'Excluir o código de conta',
    'vendor types': 'Tipos de fornecedores',
    'vendor type name': 'Nome do tipo de fornecedor',
    'add vendor type': 'Adicione o tipo de fornecedor',
    'edit vendor type': 'Editar tipo de fornecedor',
    'delete type': 'Excluir tipo',
    'document guide': 'Guia do documento',
    'document name': 'Nome do Documento',
    'document description': 'Descrição do documento',
    'mandatory': 'obrigatoriedade',
    'add vendor document': 'Adicione o documento do fornecedor',
    'edit vendor document': 'Editar documento do fornecedor',
    'delete vendor docuement': 'Excluir documento do fornecedor',
    'tax name': 'nome do imposto',
    'add tax': 'adicionar imposto',
    'edit tax': 'Editar imposto',
    'delete tax': 'Excluir imposto',
    'tax': 'imposto',
    'tax options': 'opções fiscais',
    'tax option name': 'Nome da opção fiscal',
    'sap indicator': 'Indicador sap',
    'edit tax option': 'Editar opção de imposto',
    'add tax option': 'Adicionar a opção de imposto',
    'delete tax option': 'Excluir a opção de imposto',
    'cash advance approvals': 'Aprovações de adiantamento em dinheiro',
    'approval name': 'nome de aprovação',
    'cash advance approval name': 'Nome de aprovação de adiantamento em dinheiro',
    'position': 'posição',
    'edit cash advance approval': 'Editar aprovação de adiantamento em dinheiro',
    'add cash advance approval': 'Adicionar aprovação de adiantamento em dinheiro',
    'send daily email': 'enviar e-mail diário',
    'delete cash advance approval': 'Excluir aprovação de adiantamento em dinheiro',
    'copy crew': 'cópia da equipe',
    'from previous shooting schedule': 'do cronograma de plano anterior',
    'add shooting log': 'Adicionar registro de plano',
    'edit shooting log': 'editar registro de plano',
    'delete shooting log': 'excluir registro de plano',
    'add meal': 'Adicionar refeição',
    'meal type': 'Tipo de refeição',
    'time from': 'hora desde',
    'time to': 'hora até',
    'syncronized': 'sincronizado',
    'edit vendor': 'Editar fornecedor',
    'documents': 'documentos',
    'delete catering': 'Excluir catering',
    'add cost': 'adicionar custo',
    'legalize cash advance': 'legalizar adiantamento em dinheiro',
    'reverse': 'reverter',
    'reject invoice': 'rejeitar a fatura',
    'invoices files': 'Arquivos de faturas',
    'mark on purchase order': 'marcar pedido de compra',
    'are you sure you want to mark this service as new?': 'tem certeza de que deseja marcar esse serviço como novo?',
    'are you sure you want to mark this catering as new?': 'Tem certeza de que deseja marcar esse catering como novo?',
    'view script report': 'Ver relatório de roteiro',
    'filter clips': 'filtro clipes',
    'on call': 'em chamada',
    'call to shooting': 'Chamada para plano diário',
    'mark on call': 'marcar chamada',
    'include on call sheet': 'incluir na chamada diária',
    'production centers': 'centros de produção',
    'delete production center': 'Excluir centro de produção',
    'are you sure you want to delete this production center?': 'Tem certeza de que deseja excluir este centro de produção?',
    'add production center': 'Adicionar centro de produção',
    'edit production center': 'Editar Centro de Produção',
    'office address': 'Endereço do escritório',
    'add holiday': 'Adicionar feriado',
    'edit holiday': 'Editar feriado',
    'delete holiday': 'Excluir férias',
    'are you sure you want to delete this holiday': 'tem certeza que deseja excluir este feriado?',
    'date start': 'Data inicial',
    'add task': 'Adicionar tarefa',
    'edit task': 'Editar tarefa',
    'add phase': 'Adicionar fase',
    'edit phase': 'Editar fase',
    'edit phases': 'Editar fases',
    'add phases': 'Adicionar fases',
    'delete task': 'excluir tarefa',
    'delete phase': 'excluir fase',
    'task name': 'nome da tarefa',
    'task unit': 'unidade de tarefa',
    'start at': 'Começa ás',
    'predecessor': 'antecessor',
    'jump to start': 'pular para o início',
    'add break': 'adicionar pausa',
    'edit break': 'Editar pausa',
    'change duration': 'mudar duração',
    'change quantity': 'mudar quantidade',
    'apply change to following weeks': 'Aplicar alteração nas semanas seguintes',
    'apply changes to following weeks': 'Aplicar alterações nas semanas seguintes',
    'apply change to following': 'Aplicar alteração nas seguintes',
    'apply change to same week on following tasks': 'Aplique alterações na mesma semana nas seguintes tarefas',
    'view project': 'Exibir projeto',
    'read edl': 'Ler edl',
    'episodes color box': 'Caixa de cores dos Episódios',
    'episode detail': 'Detalhes do episódio',
    'rollback episode': 'Reverter episódio',
    'rotate image': 'Girar imagem',
    'add invoice number': 'Adicionar o número da fatura',
    'edit invoice number': 'Editar o número da fatura',
    'add accounting': 'Adicionar contabilidade',
    'edit accounting': 'Editar contabilidade',
    'accounting number': 'Número contábil',
    'costs': 'custos',
    'no matching record found': 'nenhum registro correspondente encontrado',
    'clear filters': 'Limpar filtros',
    'from': 'desde',
    'history': 'história',
    'no records found': 'Nenhum registro foi encontrado',
    'view history': 'Ver histórico',
    'merge characters': 'unificar personagens',
    'into': 'em',
    'merge extras': 'unificar figuração',
    'merge sets': 'unificar sets',
    'merge locations': 'unificar locações',
    'merge elements': 'unificar elementos',
    'bulk change': 'mudança em massa',
    'show only selected by director': 'mostrar apenas selecionado pelo diretor',
    'no clips added to this scene': 'Nenhum clipe adicionado a esta cena',
    'invoice history': 'histórico da fatura',
    'service history': 'Histórico do serviço',
    'catering history': 'histórico do catering',
    'legalize support': 'legalizar apoio',
    'action': 'ação',
    'connecting to CI': 'conectando ao CI',
    'in consideration': 'em consideração',
    'in production': 'em produção',
    'past project': 'Projeto passado',
    'Login with ADFS': 'Fazer login com ADFs',
    'Login with token': 'Fazer login com token',
    'canceled': 'Cancelado',
    'This daily plan has not submit': 'Este plano diário não foi submetido',
    'No daily plan found': 'Nenhum plano diário encontrado',
    'chapter_abbr': 'cAP',
    'scene_abbr': 'cEN',
    'minute_abbr': 'mIN',
    'location_studio_abbr': 'loc/est',
    'exterior_interior_abb': 'ext/int',
    'day_night_abb': 'dia/noite',
    'projectd_minutes_abb': 'min proj',
    'average_abbr': 'méd',
    'pending_abbr': 'pend',
    'proj min': 'min proj',
    'prod prot': 'prot prod',
    'prod min': 'min prod',
    'cancel min': 'min cancel',
    'rep min': 'min rep',
    'prod_minutes_abb': 'min prod',
    'projected_abb': 'proj',
    'produced_abb': 'prod',
    'produced_scenes_abbr': 'cen prod',
    'produced_protection_abbr': 'prot prod',
    'protections_abbr': 'prot',
    'locations_abbr': 'loc',
    'day history from': 'história do dia de',
    'day history to': 'história do dia até',    
    'bud scn': 'cen prev',
    'real scn': 'cen real',
    'bud min': 'min prev',
    'real min': 'min real',
    'eff min': 'min efe',
    'eff min diff': 'dif min efe',
    'breakdown scenes on location per chapter': 'discriminação em cenas em locação por capítulo',
    'breakdown scenes on studio per chapter': 'discriminação em cenas em estúdio por capítulo',
    'breakdown scenes on location difference': 'diferença de cenas discriminadas em locação',
    'breakdown scenes on studio difference': 'diferença de cenas discriminadas em estúdio',
    'abbreviation': 'Abreviação',
    'months': 'Meses',
    'project category': 'Categoría projeto',
    'Click to add new material': 'clique para adicionar novo material',
    'click to add new tentative cast': 'clique para adicionar novo elenco provisório',
    'click to add new potencial client': 'clique para adicionar novo cliente potencial',
    'click to add new writer': 'Clique para adicionar um novo roteirista',
    'click to add new director': 'clique para adicionar novo diretor',
    'click to add new pitch': 'clique para adicionar novo pitch',
    'click to add new step': 'clique para adicionar nova etapa',
    'duplicate': 'Duplicar',
    'drag and drop image here or press to select from folder': 'Arraste e solte a imagem aqui ou pressione para selecionar da pasta',
    'project name': 'Nome do Projeto',
    'pre-production dates': 'datas pré-produção',
    'production dates': 'datas de produção',
    'post-production dates': 'datas pós-produção',
    'delete production': 'excluir produção',
    'are you sure you want to delete': 'Você tem certeza que quer deletar',
    'config': 'configuração',
    'inactivate': 'inativar',
    'statements': 'declarações',
    'click to add new project': 'Clique para adicionar novo projeto',
    'post-production': 'Pós-produção',
    'prod weeks': 'semanas prod',
    'scenes x episode': 'cenas x episódio',
    'scenes shot': 'cenas filmadas',
    'pages x episode': 'páginas x episódio',
    'pages shot': 'páginas filmadas',
    'shooting scn avg': 'média de cenas filmadas',
    'shooting pages avg': 'média de páginas filmadas',
    'shot scenes': 'cenas filmadas',
    'shot pages': 'páginas filmadas',
    'scheduled': 'agendado',
    'cast': 'elenco',
    'more days needed': 'mais dias necessários',
    'no comments added to this scene': 'nenhum comentário adicionado a esta cena',
    'pick up': 'Pegar',
    'there are no comments created on this shooting schedule': 'Não há comentários criados neste cronograma de filmagem',
    'view both': 'Ver ambos',
    'there are no shooting schedule assigned to this scene': 'não há programação de filmagem atribuída a esta cena',
    "director's notes": 'Notas do diretor',
    'other characters': 'Outros personagens',
    'view character details': 'ver detalhes do personagem',
    'add talent': 'adicionar talento',
    'role': 'Função',
    'view location details': 'ver detalhes da locação',
    'day out of days': 'dias de trabalho',
    'view set details': 'ver detalhes do set',
    'upload location image': 'carregar imagem da locação',
    'upload set image': 'carregar imagem do set',
    'edit element': 'editar elemento',
    'view element details': 'ver detalhes do elemento',
    'upload element image': 'carregar imagem do elemento',
    'are you sure you want to publish this stripboard': 'Tem certeza de que deseja publicar este stripboard',
    'select unit': 'Selecionar unidade',
    'detail': 'detalhe',
    'insert tentative': 'Adicionar provisório',
    'click to add new camera': 'clique para adicionar nova câmera',
    'sound view': 'som ao vivo',
    'view others': 'ver outros',
    'sync': 'sinc',
    'view clip': 'ver clipe',
    'reply comment': 'responder comentário',
    'approve asset': 'Aprovar ativos',
    'reject asset': 'rejeitar ativos',
    'invoices ly': 'faturas ly',
    'invoices lp': 'faturas lp',
    'undefined': 'indefinido',
    'edit project': 'editar projeto',
    'holiday': 'feriado',
    'on time': 'na hora',
	'due date': 'próximo a vencer',
	'complete late': 'completo atrasado',
	'overdue': 'atrasado',
    'category elements': 'categorias de elementos',
    'brands': 'marcas',
	'weeks cannot be decreased': 'semanas não podem ser diminuídas',
	'user already exists': 'usuário já existe',
	'live view users': 'live view - usuários',
    'delete live view user': 'excluir usuário de Live View',
	'are you sure you want to delete this live view user?': '¿tem certeza de que deseja excluir este usuário de live view?',
	'new': 'novo',
	'remove': 'remover',
    'move all to': 'mova tudo para',
	'technical analysis by scenes': 'Análise técnica por cenas',
	'chapter script report': 'Relatório de roteiro por capítulo',
	'items report': 'Report dos elementos',
	'create category element': 'criar categoria de elemento',
    'category name english': 'Nome da Categoria Inglês',
	'category name spanish': 'Nome da Categoria Espanhol',
	'category name potuguese': 'Nome da Categoria Português',
    'merge categories': 'unificar categorias',
	'delete category': 'excluir categoria',
    'edit category': 'editar categoria',

    'section title': 'Título da seção',
	'pre prod weeks': 'Semanas pre prod',
	'post weeks': 'Semanas post', 
	'wrapp weeks': 'Semanas Wrapp',
	'% studio': '% estúdio',
	'% location': '% locação',
	'location night': 'locação noite',
	'pages * episode': 'páginas * episódios',
	'avg pages * studio': 'prom pag * estúdio',
	'avg pages * location': 'prom pag * loc',
	'avg pages * loc night': 'prom pag * loc noite',
	'scenes * episode': 'cenas * episódio',
	'scenes * studio': 'cenas * estúdio',
	'scenes * location': 'cenas * locação',
	'scenes * loc night': 'cenas * loc noite',
	'1 ep pages': '1 ep páginas',
	'1 ep scenes': '1 ep cenas',
	'days per week': 'dias por semana',
	'days calendar': 'dias calendário',
	'real days': 'dias reais',
	'real participation': 'Participação real',
	'no working days': 'dias não que trabalham',
	'prod meetings': 'Reuniões de prod',
	'minutes * episode': 'minutos * episódio',
	'minutes * studio': 'minutos * estúdio',
	'minutes * location': 'minutos * locação',
	'minutes * loc night': 'minutos * loc noite',
	'add. non-working days': 'add. dias não que trabalham',
	'total non working days': 'total dias não que trabalham',
	'production trips': 'viagens de produção',
	'international trip': 'Viagem internacional',
	'national trip': 'Viagem nacional',
	'air weeks (5 days)': 'Semanas de ar (5 dias)',
	'max calls': 'max chamadas',
	'shootings off': 'planos diários off',
	'real shootings': 'planos diários reales',
	'total pages': 'páginas totais',
	'pages studio': 'páginas estúdio',
	'pages location': 'páginas locação',
	'pages exterior night': 'páginas noite exterior',
	'total minutes': 'minutos totales',
	'minutes studio': 'minutos estúdio',
	'minutes location': 'minutos locação',
	'minutes location night': 'minutos locação noite',
	'total scenes': 'total cenas',
	'scenes studio': 'cenas estúdio',
	'scenes location': 'cenas locação',
	'scenes location night': 'cenas locação noite',
	'shootings studio': 'planos diários estúdio',
	'shootings location': 'planos diários locação',
	'shootings location night': 'planos diários locação noite',
	'pages * shooting': 'páginas * plano diário',
	'pages std * shooting': 'páginas std * plano diário',
	'pages * shooting exterior': 'páginas * plano diário ext',
	'pages * shoot ext night': 'pág * plano diário ext noite',
	'minutes * shooting': 'minutos por plano diário',
	'min std * shooting': 'min std * plan diário',
	'min ext * shooting': 'min ext * plano diário',
	'min loc night * shooting': 'min loc noite * plano diário',
	'scenes * shootings': 'cenas * planos diários',
	'scn std * shooting': 'esc std * plano diário',
	'scn ext * shooting': 'esc ext * plano diário',
	'scn loc night * shoot': 'esc loc noite * plano diário',
    'parameter values': 'Valores de parâmetros',
	'totals according to parameters': 'Totais de acordo com parâmetros',
    'checked from': 'Verificado desde',
    'checked to': 'verificado para',
    'date end': 'Data final',
	'worked days': 'Dias trabalhados',
    'details': 'detalhes',
    'current month': 'Mês atual',
	'all calendar': 'Todo o calendário',
	'show range': 'Mostrar intervalo',
    'change': 'cambio',
	'show character details': 'Mostrar detalhes do personagem',
	'hide character details': 'Ocultar detalhes do personagem',
    'whitout': 'sem',
    'delete not used':'Excluir não utilizado',
	'if you change this call, this will also change all related time':'Se você alterar esta chamada, isso também alterará todo o tempo relacionado',
	'create chapter scenes':'Criar cenas de capítulo',
	'check the scenes you whant to delete all previous data otherwise system will only replace diferent values':'Verifique as cenas que deseja excluir todos os dados anteriores, caso contrário, o sistema substituirá apenas os valores diferentes',
	'create scenes': 'Crear escenas',
	'day/night': 'Dia/Noite',
    'include as general comment': 'Incluir como comentário geral',
    'catering status': 'Estado alimentar',
    'service status': 'Estado do serviço',
    'consolidated logs report': 'Relatório de logs',
    'morning snack': 'lanche da manhã',
    'afternoon snack': 'lanche da tarde',
    'wrap': 'encerramento',
    'dinner': 'jantar',
    'breakfast': 'café da manhã',
    'scene images': 'imagens de cena'
};